import { i18n } from '@/i18n';
import { TableCategory, TableHeaders } from '@/shared/components/table/models';
import { boolToYN } from '@/utils/boolToYN';

export const Categories1TableHeaders: TableHeaders[] = [
  { key: 'number', label: i18n.tc('mainTable.no'), tdClass: 'min-w-50' },
  {
    key: 'category',
    label: i18n.tc('reports.categories')
  },
  {
    key: 'date',
    label: i18n.tc('common.date')
  },
  {
    key: 'orderNumber',
    label: i18n.tc('mainTable.wo')
  },
  {
    key: 'billTo',
    label: i18n.tc('order.billTo')
  }
];

export const EquipmentTableHeaders = [
  {
    key: 'containerNumber',
    label: i18n.tc('order.cont')
  },
  {
    key: 'shippingLine',
    rendererKey: 'equipment',
    label: i18n.tc('order.ssl'),
    collapsed: true
  },
  {
    key: 'containerSize',
    rendererKey: 'equipment',
    label: i18n.tc('mainTable.sz'),
    collapsed: true
  },
  {
    key: 'chassisNumber',
    rendererKey: 'equipment',
    label: i18n.tc('order.chassisNumber'),
    collapsed: true
  },
  {
    key: 'chassisPool',
    rendererKey: 'equipment',
    label: i18n.tc('order.chassisPool'),
    collapsed: true
  },
  {
    key: 'bondEntry',
    rendererKey: 'equipment',
    label: i18n.tc('mainTable.bond'),
    collapsed: true
  }
];

export const InfoTableHeaders: TableHeaders[] = [
  {
    key: 'masterBillOfLading',
    label: i18n.tc('mainTable.mbl')
  },
  {
    key: 'referenceNumber',
    label: i18n.tc('mainTable.ref'),
    rendererKey: 'info',
    collapsed: true
  },
  {
    key: 'poNumber',
    rendererKey: 'info',
    label: i18n.tc('mainTable.po'),
    collapsed: true
  },
  {
    key: 'weight',
    rendererKey: 'info',
    label: i18n.tc('order.weight'),
    collapsed: true
  },
  {
    key: 'quantity',
    rendererKey: 'info',
    label: i18n.tc('order.quantity'),
    collapsed: true
  },
  {
    key: 'overHeight',
    rendererKey: 'info',
    label: i18n.tc('order.oh'),
    formatter: boolToYN,
    collapsed: true
  },
  {
    key: 'overWeight',
    rendererKey: 'info',
    label: i18n.tc('order.ow'),
    formatter: boolToYN,
    collapsed: true
  },
  {
    key: 'haz',
    rendererKey: 'info',
    label: i18n.tc('order.haz'),
    formatter: boolToYN,
    collapsed: true
  },
  {
    key: 'hot',
    rendererKey: 'info',
    label: i18n.tc('order.hot'),
    formatter: boolToYN,
    collapsed: true
  }
];

export const Categories2TableHeaders: TableHeaders[] = [
  {
    key: 'eta',
    label: i18n.tc('order.vesselEta')
  },
  {
    key: 'lastFreeDay',
    label: i18n.tc('order.lfd')
  },
  {
    key: 'avaDate',
    label: i18n.tc('mainTable.avd')
  },
  {
    key: 'streetTurn',
    label: i18n.tc('order.st')
  },
  {
    key: 'returnFreeDay',
    label: i18n.tc('order.rfd')
  }
];

export const POutTableHeaders: TableHeaders[] = [
  {
    key: 'pulloutLocation',
    label: i18n.tc('mainTable.pOut'),
    tdClass: 'min-w-130'
  },
  {
    key: 'pulloutSchedule',
    rendererKey: 'pOut',
    label: i18n.tc('mainTable.scheIn'),
    tdClass: 'min-w-130'
  },
  {
    key: 'pulloutActualIn',
    rendererKey: 'pOut',
    label: i18n.tc('mainTable.actualIn'),
    tdClass: 'min-w-130'
  },
  {
    key: 'pulloutActualOut',
    rendererKey: 'pOut',
    label: i18n.tc('mainTable.actualOut'),
    tdClass: 'min-w-130'
  },
  {
    key: 'pulloutDriver',
    rendererKey: 'pOut',
    label: i18n.tc('mainTable.drv'),
    tdClass: 'min-w-130'
  }
];

export const DilvTableHeaders: TableHeaders[] = [
  {
    key: 'deliveryLocation',
    label: i18n.tc('mainTable.dilv'),
    tdClass: 'min-w-130'
  },
  {
    key: 'deliverySchedule',
    rendererKey: 'dilv',
    label: i18n.tc('mainTable.scheIn'),
    tdClass: 'min-w-130'
  },
  {
    key: 'deliveryActualIn',
    rendererKey: 'dilv',
    label: i18n.tc('mainTable.actualIn'),
    tdClass: 'min-w-130'
  },
  {
    key: 'deliveryActualOut',
    rendererKey: 'dilv',
    label: i18n.tc('mainTable.actualOut'),
    tdClass: 'min-w-130'
  },
  {
    key: 'deliveryDriver',
    rendererKey: 'dilv',
    label: i18n.tc('mainTable.drv'),
    tdClass: 'min-w-130'
  }
];

export const PUTableHeaders: TableHeaders[] = [
  {
    key: 'pickupLocation',
    label: i18n.tc('mainFilters.pickUp'),
    tdClass: 'min-w-130'
  },
  {
    key: 'emptyConfirmation',
    rendererKey: 'pU',
    label: i18n.tc('order.emptyCFM'),
    tdClass: 'min-w-130'
  },
  {
    key: 'pickupSchedule',
    rendererKey: 'pU',
    label: i18n.tc('mainTable.scheIn'),
    tdClass: 'min-w-130'
  },
  {
    key: 'pickupActualIn',
    rendererKey: 'pU',
    label: i18n.tc('mainTable.actualIn'),
    tdClass: 'min-w-130'
  },
  {
    key: 'pickupActualOut',
    rendererKey: 'pU',
    label: i18n.tc('mainTable.actualOut'),
    tdClass: 'min-w-130'
  },
  {
    key: 'pickupDriver',
    rendererKey: 'pU',
    label: i18n.tc('mainTable.drv'),
    tdClass: 'min-w-130'
  }
];

export const RtnTableHeaders: TableHeaders[] = [
  {
    key: 'returnLocation',
    label: i18n.tc('mainTable.rtn'),
    tdClass: 'min-w-130'
  },
  {
    key: 'returnSchedule',
    rendererKey: 'rtn',
    label: i18n.tc('mainTable.scheIn'),
    tdClass: 'min-w-130'
  },
  {
    key: 'returnActualIn',
    rendererKey: 'rtn',
    label: i18n.tc('mainTable.actualIn'),
    tdClass: 'min-w-130'
  },
  {
    key: 'returnActualOut',
    rendererKey: 'rtn',
    label: i18n.tc('mainTable.actualOut'),
    tdClass: 'min-w-130'
  },
  {
    key: 'returnDriver',
    rendererKey: 'rtn',
    label: i18n.tc('mainTable.drv'),
    tdClass: 'min-w-130'
  }
];

export const ArTableHeaders: TableHeaders[] = [
  {
    key: 'ar',
    label: i18n.tc('mainTable.ar')
  },
  {
    key: 'arTruckingCharges',
    rendererKey: 'ar',
    label: i18n.tc('mainTable.trucking')
  },
  {
    key: 'arFuelSurCharges',
    rendererKey: 'ar',
    label: i18n.tc('mainTable.fscR')
  },
  {
    key: 'arChassis',
    rendererKey: 'ar',
    label: i18n.tc('mainTable.chR')
  },
  {
    key: 'arPerdiem',
    rendererKey: 'ar',
    label: i18n.tc('mainTable.peR')
  },
  {
    key: 'arDemurrage',
    rendererKey: 'ar',
    label: i18n.tc('mainTable.deR')
  },
  {
    key: 'arDryRun',
    rendererKey: 'ar',
    label: i18n.tc('mainTable.drR')
  }
];

export const ApTableHeaders: TableHeaders[] = [
  {
    key: 'apPerdiem',
    label: i18n.tc('mainTable.ap')
  },
  {
    key: 'apDryRun',
    rendererKey: 'ap',
    label: i18n.tc('mainTable.drvP')
  },
  {
    key: 'apChassisFees',
    rendererKey: 'ap',
    label: i18n.tc('mainTable.chP')
  },
  {
    key: 'apPerdiem1',
    rendererKey: 'ap',
    label: i18n.tc('mainTable.peP')
  },
  {
    key: 'apDemurrage',
    rendererKey: 'ap',
    label: i18n.tc('mainTable.deP')
  },
  {
    key: 'apDriverPay',
    rendererKey: 'ap',
    label: i18n.tc('mainTable.drP')
  }
];

export const Categories3TableHeaders: TableHeaders[] = [
  {
    key: 'profit',
    label: i18n.tc('mainTable.prft')
  },
  {
    key: 'inv',
    label: i18n.tc('mainTable.inv')
  }
];

export const DocumentTableHeaders: TableHeaders[] = [
  {
    key: 'filePod',
    label: i18n.tc('mainTable.pod'),
    formatter: boolToYN
  },
  {
    key: 'fileBl',
    rendererKey: 'document',
    label: i18n.tc('mainTable.bl'),
    formatter: boolToYN
  },
  {
    key: 'fileDo',
    rendererKey: 'document',
    label: i18n.tc('mainTable.do'),
    formatter: boolToYN
  },
  {
    key: 'fileIt',
    rendererKey: 'document',
    label: i18n.tc('mainTable.it'),
    formatter: boolToYN
  }
];

export const Categories4TableHeaders: TableHeaders[] = [
  {
    key: 'remarks',
    label: i18n.tc('order.remarks')
  }
];

export const ImportRegularCategoriesHeaders: TableCategory[] = [
  {
    key: 'category1',
    label: ' ',
    maxColspan: Categories1TableHeaders.length,
    minColspan: 1
  },
  {
    key: 'equipment',
    label: i18n.tc('mainTable.headers.equipment'),
    maxColspan: EquipmentTableHeaders.length,
    minColspan: 1,
    class: 'equipment-color',
    collapsed: true,
    opportunityСhange: true
  },
  {
    key: 'info',
    label: i18n.tc('mainTable.headers.info'),
    maxColspan: InfoTableHeaders.length,
    minColspan: 1,
    class: 'info-color',
    collapsed: true,
    opportunityСhange: true
  },
  {
    key: 'category2',
    label: '',
    maxColspan: Categories2TableHeaders.length,
    minColspan: 1
  },
  {
    key: 'pOut',
    label: i18n.tc('mainTable.headers.pOutD'),
    maxColspan: POutTableHeaders.length,
    minColspan: 1,
    class: 'p-out-color',
    opportunityСhange: true
  },
  {
    key: 'dilv',
    label: i18n.tc('mainTable.headers.dilvD'),
    maxColspan: DilvTableHeaders.length,
    minColspan: 1,
    class: 'dilv-color',
    opportunityСhange: true
  },
  {
    key: 'pU',
    label: i18n.tc('mainTable.headers.puD'),
    maxColspan: PUTableHeaders.length,
    minColspan: 1,
    class: 'p-u-color',
    opportunityСhange: true
  },
  {
    key: 'rtn',
    label: i18n.tc('mainTable.headers.rtnD'),
    maxColspan: RtnTableHeaders.length,
    minColspan: 1,
    class: 'rtn-color',
    opportunityСhange: true
  },
  {
    key: 'ar',
    label: i18n.tc('mainTable.headers.ar'),
    maxColspan: ArTableHeaders.length,
    minColspan: 1,
    class: 'ar-color',
    opportunityСhange: true
  },
  {
    key: 'ap',
    label: i18n.tc('mainTable.headers.ap'),
    maxColspan: ApTableHeaders.length,
    minColspan: 1,
    class: 'ap-color',
    opportunityСhange: true
  },
  {
    key: 'category3',
    label: '',
    maxColspan: Categories3TableHeaders.length,
    minColspan: 1
  },
  {
    key: 'document',
    label: i18n.tc('mainTable.headers.doc'),
    maxColspan: DocumentTableHeaders.length,
    minColspan: 1,
    class: 'document-color',
    opportunityСhange: true
  },
  {
    key: 'category4',
    label: '',
    maxColspan: Categories4TableHeaders.length,
    minColspan: 1
  }
];

export const ImportRegularTableHeaders: TableHeaders[] = [
  ...Categories1TableHeaders,
  ...EquipmentTableHeaders,
  ...InfoTableHeaders,
  ...Categories2TableHeaders,
  ...POutTableHeaders,
  ...DilvTableHeaders,
  ...PUTableHeaders,
  ...RtnTableHeaders,
  ...ArTableHeaders,
  ...ApTableHeaders,
  ...Categories3TableHeaders,
  ...DocumentTableHeaders,
  ...Categories4TableHeaders
];
